<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '420px' }"
    header="Fomulário de Setores"
    :modal="true"
    @hide="hideDialog"
  >
    <div class="p-fluid formgrid grid">
      <div class="field col-12">
        <label for="desc">Nome do Setor</label>
        <InputText
          id="des"
          v-model="v$.subUnidade.descricao.$model"
          maxlength="100"
          placeholder="Digite o nome do setor"
          :class="{
            'p-invalid': submitted && v$.subUnidade.descricao.$invalid,
          }"
        />
        <small
          v-if="submitted && v$.subUnidade.descricao.$invalid"
          class="p-error"
          >Nome do Setor é obrigatório.</small
        >
      </div>

      <div class="field col-12">
        <label for="desc">Unidade</label>
        <Dropdown
          id="group"
          v-model="v$.subUnidade.unidade.$model"
          :options="allUnidades"
          optionLabel="descricao"
          placeholder="Selecione a unidade que o setor pertence"
          :class="{
            'p-invalid': submitted && v$.subUnidade.unidade.$invalid,
          }"
        />
        <small
          v-if="submitted && v$.subUnidade.unidade.$invalid"
          class="p-error"
          >Unidade é obrigatório.</small
        >
      </div>
    </div>
      <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.subUnidade.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import SubUnidade from "../../../models/subUnidade";

//Services
import SubUnidadeService from "../../../service/subUnidade/subUnidadeService";
import UnidadeService from "../../../service/unidade/unidadeService";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["selected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      allUnidades: [],
      subUnidade: new SubUnidade(),
      subUnidadeService: new SubUnidadeService(),
      unidadeService: new UnidadeService(),
      submitted: false,
    };
  },
  validations() {
    return {
      subUnidade: new SubUnidade().validations(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.setores.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.setores.dialogForm = value;
      },
    },
  },
  methods: {
    send(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        if (this.subUnidade.id) {
          this.update();
        } else {
          this.create();
        }
      } else {
        return;
      }
    },

    create() {
      this.subUnidadeService
        .create(this.subUnidade)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.subUnidadeService
        .update(this.subUnidade)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    hideDialog() {
      this.subUnidade = new SubUnidade();
      this.submitted = false;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    getData() {
      this.subUnidade = this.selected;
      this.findUnidades();
    },
    findUnidades() {
      this.unidadeService.findAll().then((data) => {
        this.allUnidades = data;
      });
    },
  },
};
</script>
<style scoped></style>
